import React from 'react';
import { Box, Heading, Flex } from '@chakra-ui/react';
import DepthChart from '../components/DepthChart';

const DepthChartPage = () => (
  <Box p={8} color="white">
    <Flex align="center" mb={6} gap={4}>
      <Heading
        as="h1"
        fontFamily="Audiowide"
        fontWeight="bold"
        color="white"
        flex="1"
        textAlign="left"
        fontSize="2xl"
        m={0}
        p={0}
        whiteSpace="nowrap"
      >
        Depth Chart
      </Heading>
    </Flex>
    <DepthChart />
  </Box>
);

export default DepthChartPage;